// src/pages/AdminPage.jsx
import React from 'react';

const AdminPage = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Admin Panel</h1>
      <p>Bienvenido al panel de administración.</p>
    </div>
  );
};

export default AdminPage;
